// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"707676e4","410":"f2cc365b","453":"762c2a57","732":"4052a2df","977":"f4d65c30"}[chunkId] + ".chunk.js";
};